import { render, staticRenderFns } from "./chbProductDetails.vue?vue&type=template&id=44e57743&scoped=true"
import script from "./chbProductDetails.vue?vue&type=script&lang=js"
export * from "./chbProductDetails.vue?vue&type=script&lang=js"
import style0 from "./chbProductDetails.vue?vue&type=style&index=0&id=44e57743&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e57743",
  null
  
)

export default component.exports